import { render, staticRenderFns } from "./custom-form-commerce.vue?vue&type=template&id=41348884&scoped=true&"
import script from "./custom-form-commerce.vue?vue&type=script&lang=js&"
export * from "./custom-form-commerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41348884",
  null
  
)

export default component.exports